import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Form} from 'forms/rrf';
import {Button, Col, Container, Row} from 'react-bootstrap';
import numeral from 'numeral';
import IgniteDataTable from '../../../common/datatable';
import SectionTitle from '../../../common/section-title/index';
import FileUpload from '../../../common/form/elements/file-upload';
import ArrowButton from '../../../common/button-arrow';
import {deleteFile, getFiles, uploadFile} from '../../../../actions/files';
import store, {history} from '../../../../store';
import ConfirmPopup from '../../../common/confirm-popup';

import './styles.css';

class Downloads extends Component {
  state = {
    pageNumber: 1,
    delete: {
      show: false
    }
  };

  handlePageChange = (page) => {
    this.setState({ pageNumber: page }, this.afterPageChange);
  };

  afterPageChange = () => {
    const { pageNumber } = this.state;

    this.props.dispatch(getFiles(pageNumber));
  };
  handleSubmit = (payLoad) => {
    const { pageNumber } = this.state;
    this.props.dispatch(actions.submitFields('deep.admin_files.upload', uploadFile(payLoad)))
      .then(() => {
        this.props.dispatch(getFiles(pageNumber));
        this.fileUpload.reset();
      });
  };

  UNSAFE_componentWillMount() {
    const { pageNumber } = this.state;
    this.props.dispatch(getFiles(pageNumber));
  }

  render() {
    const {
      current_page: currentPage, per_page: perPage, total_count: totalCount
    } = this.props.paging;
    const columns = [
      {
        prop: 'name',
        title: 'Filename'
      },
      {
        prop: 'size',
        title: 'Size',
        width: '150',
        format(cell) {
          return numeral(cell)
            .format('0.00 b');
        }
      },
      {
        prop: 'permalink',
        title: 'Permalink',
        width: '150',
        format(cell) {
          return (
            <Button variant="link" href={cell} target="_blank">
              Permalink
            </Button>
          );
        },
      },
    ];

    const fileActions = [
      {
        label: 'Edit',
        callback: (row) => {
          history.push(`/admin/downloads/${row.id}`);
        }
      },
      {
        label: 'Delete',
        color: 'grey',
        callback: (row) => {
          this.setState({
            delete: {
              show: true,
              id: row.id
            }
          });
        }
      }
    ];

    const handleDelete = (result) => {
      const {id} = this.state.delete;
      this.setState({delete: {show: false}});
      if (result) {
        store.dispatch(deleteFile(id));
      }
    };
    return (
      <Container fluid className="files">
        <Row>
          <Col md={12}>
            <SectionTitle>
              Upload a new File
            </SectionTitle>
          </Col>
        </Row>
        {/* The Form must WRAP the Row, not the reverse: BS3 floats let the two Cols sit
            side by side even though the <form> was the .row's only child, but BS5 flex
            only lays out .col-* that are DIRECT children of a .row — so the Cols stacked
            (IGN-2367 "wrong layout for file upload"). Nest the Row inside the Form. */}
        <Form model="deep.admin_files.upload" onSubmit={this.handleSubmit}>
          <Row>
            <Col lg={6}>
              <FileUpload
                label="1. Choose a File"
                ref={(instance) => {
                  this.fileUpload = instance;
                }}
                required
              />
            </Col>
            <Col lg={6}>
              <h4>
                2. Upload
              </h4>
              <ArrowButton ghost={false}>
                Upload file
              </ArrowButton>
            </Col>
          </Row>
        </Form>

        <Row>
          <Col md={12}>
            <SectionTitle>
              Download library
            </SectionTitle>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div>
              <IgniteDataTable
                actions={fileActions}
                actionWidth="280"
                columns={columns}
                data={this.props.files}
                dataSize={parseInt(totalCount)}
                pagination={{
                  page: parseInt(currentPage),
                  sizePerPage: parseInt(perPage),
                  onPageChange: this.handlePageChange.bind(this),
                }}
                remote
              />

              {
                this.state.delete.show && (
                  <ConfirmPopup
                    header="DELETE FILE?"
                    onClose={handleDelete}
                  >
                    <p>
                      Are you sure you want to delete the selected file?
                    </p>
                  </ConfirmPopup>
                )}
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  files: state.files.list,
  fetching: state.files.fetching,
  fetched: state.files.fetched,
  paging: state.files.paging,
});

export default connect(mapStateToProps)(Downloads);
